module.exports = __webpack_public_path__ + "img/bmcode.e5fc621f.gif";